module.exports = {
  1: { api: 1, human: 'Versicherungsnehmer' },
  2: { api: 2, human: 'Versicherungsnehmer + Partner' },
  3: { api: 3, human: 'Versicherungsnehmer + Partner + Kinder' },
  4: { api: 4, human: 'Sonstige' }
}
